import { render, staticRenderFns } from "./ModalDepositDetailRecord.vue?vue&type=template&id=2961b01d&"
import script from "./ModalDepositDetailRecord.vue?vue&type=script&lang=js&"
export * from "./ModalDepositDetailRecord.vue?vue&type=script&lang=js&"
import style0 from "./ModalDepositDetailRecord.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports